import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '../../app.constants';
import { AdminVolumetryWidgetApi, EntityVolumetryApi } from './models/admin-volumetry-api';

@Injectable({
    providedIn: 'root'
})
export class AdminVolumetryApiService {
    private readonly baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = `${AppConstants.Configuration.apiUrlHist}/hist/netbackup/admin/volumetry`;
    }

    getVolumetryWidget(offset: number = 0): Observable<AdminVolumetryWidgetApi> {
        return this.http.get<AdminVolumetryWidgetApi>(`${this.baseUrl}/widget?offset=${offset}`);
    }

    getVolumetryDetail(months: number = 13): Observable<EntityVolumetryApi[]> {
        return this.http.get<EntityVolumetryApi[]>(`${this.baseUrl}?months=${months}`);
    }
}
